module.exports = __webpack_public_path__ + "static/media/config-hist.d714faa9.png";